import i18next from 'i18next';

i18next.addResources('es_CL', 'Cart', {
  quantity: '{{quantity}} items',
  goToCart: 'Ir a pagar',
  order: 'Ir a pagar',
  seeCart: 'Ver pedido'
});
